import { faEdit, faEye, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Table,} from "reactstrap";
import './dealTableChart.css';
import axios from "axios";
import Config from '../../config.json'

const GlobalTable = ({ headers, data, onDelete,onEdit}) => {
    return (
        <div className='deal-table-chart'>
            <Table striped bordered className="table-pad margin-top-18">
                <thead className="bg-header">
                    <tr>
                        <th className="width-64 left-th" style={{position : 'sticky', left : '0',background:'#018ee0'}}>Action</th>
                        {headers.map((one,k) => {
                            return (
                            k == 0 ? <th className=" width-75 middle-th" style={{position : 'sticky', left : '53px',background:'#018ee0'}}>{one.label}</th>
                            :
                            <th className=" width-75 middle-th" >{one.label}</th>)
                        })}
                    </tr>
                </thead>
                <tbody className="font12">
                    {data && data?.map((info, i) => {
                        return (
                            <tr>
                                <td className="pad0" scope="row" style={{position : 'sticky', left : '0', background: "#dbeef9"}}>
                                    <Button className="btn btn-info btn-info2" style={{margin : '3px 3px 3px 0'}}
                                    >
                                        <FontAwesomeIcon
                                            className="float-right"
                                            icon={faEdit}
                                            onClick={() => {
                                                onEdit(info, i);

                                            }
                                            }

                                        />
                                    </Button>
                                    <Button className="btn btn-danger btn-info2"
                                    >
                                        <FontAwesomeIcon
                                            className="float-right"
                                            icon={faTrashAlt}
                                            onClick={() => onDelete(info,i)}
                                        />
                                    </Button>
                                </td>
                                {headers?.map((header, k) => {
                                    return <td>
                                        {info[header.field]}
                                    </td>
                                })}
                            </tr>
                        );

                    })}

                    {/* <tr>
                        <td className="pad0" scope="row" style={{position : 'sticky', left : '0',background:'#dbeef9'}}>
                            <Button className="btn-wwp-plus"
                                onClick={addOnClick}
                            >
                                +
                            </Button>
                        </td>
                        {headers.map((one, i) => {
                            return (i== 0 ?
                            <td style={{position : 'sticky', left : '53px',background :'#dbeef9', display : "none"}}></td>
                            // : i ==1 ? 
                            // <td style={{position : 'sticky', left : '160px',background :'#dbeef9', display : "none"}}></td>
                            : 
                            <td style={{display : "none"}}></td>
                            )
                        })}
                    </tr> */}
                    {/* {total ? <tr>
                        <td>Total</td>
                        {headers.map((one) => {
                            if(one.value !== "System_Size_KW1"){
                                if (total[one.value]) {
                                    return <td>{total[one.value]}</td>
                                } else {
                                    return <td></td>
                                }
                            }else{
        
                                if (total[one.value]) {
                                    let t=Number(total[one.value])
                                    console.log("t:        ", t);
                                    return <td>{t.toFixed(3)}</td>
                                } else {
                                    return <td></td>
                                }
                            }

                        })}


                    </tr> : <></>} */}
                </tbody>
            </Table>
        </div>

    );
}

export default GlobalTable;